// extracted by mini-css-extract-plugin
export default {"map":"Map_map__sC7kC","button":"Map_button__xoM-3"};